export default __webpack_public_path__ + "assets/images/0f4d9d7f23633b1d38e9bcdafafdaa47.png";